import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Modal, Ripple } from "arv-reactcomponents";
import { SHOP_MULTILPE, MASTERTEMPLATE } from "npmlinks-constants";
import ShopAllStylesModal from "../ShopAllStylesModal";
import Event from "../../../analytics/eventFactory";
import Analytics from "../../../analytics";

class ShopAllStyles extends Component {
  constructor() {
    super();
    this.state = {
      modalOpen: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }
  openModal() {
    this.setState({ modalOpen: true });
    const { sectionIndex, componentIndex, identity } = this.props;
    Analytics.trackEvent({
      category: MASTERTEMPLATE.BT,
      action: Event.action.getMasterTemplateActions([
        sectionIndex,
        Event.action.MASTER_TEMPLATE_PAGES.BT_PCAR_SALL,
      ]),
      label: Event.label.getMasterTemplateLabels([componentIndex, identity]),
    });
  }
  closeModal() {
    this.setState({ modalOpen: false });
  }
  render() {
    const { modalOpen } = this.state;
    const { buttonText, styleIdList, title } = this.props;
    return (
      <div className="nw-shopallstyles-container">
        <Ripple className="nwc-ripple-light">
          <Button
            onClick={this.openModal}
            className="nwc-btn-primary nw-shopallstyles-button"
            style={{ color: buttonText.color }}
          >
            {buttonText.text || SHOP_MULTILPE.SHOP_ALL_STYLES.BUTTON_TEXT}
          </Button>
        </Ripple>
        <Modal
          isOpen={modalOpen}
          onClose={this.closeModal}
          className="nw-shopallstyles-modal"
        >
          <ShopAllStylesModal.component
            styleIdList={styleIdList}
            title={title}
            closeModal={this.closeModal}
          />
        </Modal>
      </div>
    );
  }
}

ShopAllStyles.defaultProps = {
  buttonText: { text: SHOP_MULTILPE.SHOP_ALL_STYLES.BUTTON_TEXT },
  styleIdList: [],
};

ShopAllStyles.propTypes = {
  sectionIndex: PropTypes.number.isRequired,
  componentIndex: PropTypes.number.isRequired,
  identity: PropTypes.string.isRequired,
  buttonText: PropTypes.shape({}),
  styleIdList: PropTypes.shape([]),
  title: PropTypes.shape({}).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ShopAllStyles,
  component: ShopAllStyles,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ShopMultiple/ShopAllStyles/index.js